import { AddwithWhiteCircle, Attachment, DropdownArrow } from "./AllSvg";
import CreatableSelect from 'react-select/creatable';
import { useState } from 'react';


const statesAndUTs = [
  "ANDHRA PRADESH",
  "ARUNACHAL PRADESH",
  "ASSAM",
  "BIHAR",
  "CHHATTISGARH",
  "GOA",
  "GUJARAT",
  "HARYANA",
  "HIMACHAL PRADESH",
  "JHARKHAND",
  "KARNATAKA",
  "KERALA",
  "MADHYA PRADESH",
  "MAHARASHTRA",
  "MANIPUR",
  "MEGHALAYA",
  "MIZORAM",
  "NAGALAND",
  "ODISHA",
  "PUNJAB",
  "RAJASTHAN",
  "SIKKIM",
  "TAMIL NADU",
  "TELANGANA",
  "TRIPURA",
  "UTTAR PRADESH",
  "UTTARAKHAND",
  "WEST BENGAL",
  "ANDAMAN AND NICOBAR ISLANDS",
  "CHANDIGARH",
  "DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
  "LAKSHADWEEP",
  "DELHI",
  "PUDUCHERRY",
  "LADAKH",
  "JAMMU AND KASHMIR"
];



const toTitleCase = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};



const toCamelCase = (str) => {
  if (!str) return '';
  return str.charAt(0).toLowerCase() + str.slice(1);
};

const DocumentSection = ({ formData, handleDocInputChange, handleAddDocuments, handleRemoveDocument, errors, fileNames, inputState }) => (
  <>
    <div className="jd-heading-outer heading-bg-color-white">
      <div className="jd-heading-outer-flex">
        <h2 className="jd-heading-main font-weight600 font-size-heading">Documents</h2>
        <button
          title="Add Documents"
          onClick={handleAddDocuments}
          className="upload-svg"
          style={{ float: "right" }}
          type="button" // Set the button type to "button"
        >
          <AddwithWhiteCircle /> Add Document
        </button>
      </div>
      <div>
        <div className="jd-heading-bottom-bold"></div>
        <div className="jd-heading-bottom-light"></div>
      </div>
    </div>

    {formData.documents.map((doc, index) => (
      <div key={index} className="form-flex-wrap" style={{ marginBottom: "50px" }}>
        <div className="flex-row" style={{ alignItems: 'flex-start' }}>
          <div className="flex-column">
            <label htmlFor={`document_name_${index}`} className="form-labels font-weight500 font-size-subheading">
              {index === 0 ? "Letter Name" : "Attachment Name"}<span className="required">*</span>
            </label>
            <input
              type="text"
              id={`document_name_${index}`}
              name="document_name"
              placeholder={index === 0 ? "Example: AE L No-01 Dated-DD/MM/YYYY" : "Write Only 3-4 Words"}
              value={doc.document_name}
              onChange={(e) => handleDocInputChange(index, e)}
              className={`form-input ${errors[`document_name_${index}`] ? 'error' : inputState[`document_name`] ? 'success' : ''}`}
            />
            <div style={{ height: errors[`document_name_${index}`] }}>

              {errors[`document_name_${index}`] && (
                <span className="error-message font-size-text">{errors[`document_name_${index}`]}</span>
              )}
            </div>
          </div>

          <div className="flex-column field-cont-div" style={{ marginLeft: "60px", alignItems: 'start' }}>
            <label htmlFor={`document_file_${index}`} className="form-labels announce-date font-weight500 font-size-heading">
              {index === 0 ? "Upload Letter Document" : "Upload File"}<span className="required">*</span>
            </label>
            <label
              htmlFor={`document_file_${index}`}
              className={` custom-file-upload ${errors[`document_file_${index}`] ? 'error' : inputState[`document_file`] ? 'success' : ''}`}
            >
              <div className={`align-center pdf-input width-10vw  ${errors[`document_file_${index}`] ? 'error' : ''}`} style={{ margin: "8px 0px 20px 0px", height: "30px" }}>
                <Attachment />
              </div>
            </label>
            <input
              id={`document_file_${index}`}
              name="document_file"
              type="file"
              onChange={(e) => handleDocInputChange(index, e)}
              style={{ display: 'none', position: 'relative' }}
            />
            <div style={{ whiteSpace: "normal", height: errors[`document_file_${index}`] && "5vh", }} >
              {errors[`document_file_${index}`] && (
                <span className="error-message font-size-text">{errors[`document_file_${index}`]}</span>
              )}
            </div>
            {/* <div style={{ whiteSpace: "normal", width: "12vw", height: fileNames[index] && "2vh", }} >
              {fileNames[index]?.length > 20
                ? `${fileNames[index].substring(0, 20)}...`
                : fileNames[index]}
            </div> */}


          </div>
          {doc.document_file && (

            <div class="tooltip-container" style={{ top: "35px", left: "40px" }}>
              <span class="tooltip"> {doc.original_filename}</span>
              <span class="text">!</span>
            </div>
          )}
        </div>

        {index > 0 && (
          <div className="flex-column justify-center">
            <div style={{ marginTop: "25px" }}>
              <button type="button" className="file-clear clear-button width-10vw" onClick={() => handleRemoveDocument(index)}>
                Remove
              </button>
            </div>
          </div>
        )}
      </div>
    ))}
  </>
);



const RenderInputField = ({ title, name, required, type = 'text', placeholder, max, formData, errors, inputState, isReadOnly, disabled, handleInputChange }) => (
  <div title={title} className="flex-column">
    <label htmlFor={name} className="form-labels font-weight500 font-size-subheading">
      {title}{required ? <span className="required">{isReadOnly ? "(Read-Only)" : "*"}</span> : null}
    </label>
    <input
      type={type}
      id={name}
      name={name}
      max={max}
      disabled={disabled}
      placeholder={placeholder}
      value={formData[name]}
      onChange={handleInputChange}
      className={`form-input ${errors[name] ? 'error' : inputState[name] ? 'success' : ''}`}
    />
    {/* {errors[name] && <span className="error-message font-size-text">{errors[name]}</span>} */}
  </div>
);


const RenderDateInputField = ({ title, name, required, type = 'date', placeholder, max, formData, errors, inputState, handleInputChange }) => {
  const [localError, setLocalError] = useState("");

  const handleChange = (e) => {
    let { value } = e.target;
    let errorMessage = "";

    if (type === "date" && max && value > max) {
      errorMessage = `Date cannot be later than ${max}`;
    }

    setLocalError(errorMessage);

    handleInputChange({ target: { name, value: errorMessage ? formData[name] : value } });
  };

  return (
    <div title={title} className="flex-column">
      <label htmlFor={name} className="form-labels font-weight500 font-size-subheading">
        {title}{required ? <span className="required">*</span> : null}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        max={max}
        placeholder={placeholder}
        value={formData[name]}
        onChange={handleChange}
        className={`form-input ${errors[name] || localError ? 'error' : inputState[name] ? 'success' : ''}`}
      />
      {localError && <span className="error-message font-size-text">{localError}</span>}
    </div>
  );
};


const RenderInputTextareaField = ({
  title,
  name,
  required,
  placeholder,
  max, // Optional: max length
  formData,
  errors,
  inputState,
  handleInputChange,
  disabled,
  isReadOnly,
  rows = 5, // Default value
  cols = 50 // Default value
}) => (
  <div title={title} className="flex-column">
    <label htmlFor={name} className="form-labels font-weight500 font-size-subheading">
      {title}
      {required ? <span className="required">{isReadOnly ? "(Read-Only)" : "*"}</span> : null}
    </label>
    <textarea
      id={name}
      name={name}
      rows={rows}
      cols={cols}
      placeholder={placeholder}
      value={formData[name]}
      disabled={disabled}
      onChange={handleInputChange}
      maxLength={max} // Optional max length attribute
      className={`form-textarea form-textarea2 ${errors[name] ? 'error' : inputState[name] ? 'success' : ''}`}
      style={{ whiteSpace: 'pre-wrap' }} // Preserve new lines and spaces
    />
    {/* {errors[name] && <span className="error-message font-size-text">{errors[name]}</span>} */}
  </div>
);




const RenderSelectField = ({ title, placeholderneed, name, isReadOnly, required, options, placeholder, disabled, formData, errors, inputState, handleInputChange, multiple = false }) => (
  <div title={title} className="flex-column form-group-selectt">
    <label htmlFor={name} className="form-labels font-weight500 font-size-subheading">
      {title}{required ? <span className="required">{isReadOnly ? "(Read-Only)" : "*"}</span> : null}
    </label>
    <br />
    <select
      id={name}
      name={name}
      value={formData[name]}
      onChange={handleInputChange}
      className={`form-input form-group-selection ${errors[name] ? 'error' : inputState[name] ? 'success' : ''}`}
      disabled={disabled}
      multiple={multiple}
    >
      {placeholderneed === "NO" ? "" :
        <option value="null" disabled>{placeholder}</option>
      }
      {options.map((option, index) => (
        <option key={index} value={option.value}>{option.label}</option>
      ))}
    </select>
    {/* <DropdownArrow /> */}
    {/* {errors[name] && <span className="error-message font-size-text">{errors[name]}</span>} */}
  </div>
);




const InputTextField = ({
  title,
  htmlFor,
  name,
  type = "text",
  placeholder,
  onChange,
  value,
  errors,
  inputState
}) => {

  console.log(inputState[name])
  return (
    <div title={title} className="flex-column">
      <label htmlFor={htmlFor} className="form-labels font-weight500 font-size-subheading">
        {title}<span className="required">*</span>
      </label>
      <input
        type={type}
        id={htmlFor}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        className={`form-input ${errors[name] ? "error" : inputState[name] ? "success" : ""}`}
      />
      {errors[name] && <span className="error-message font-size-text">{errors[name]}</span>}
    </div>
  );
};




export { statesAndUTs, toTitleCase, toCamelCase, InputTextField, DocumentSection, RenderInputField, RenderDateInputField, RenderSelectField, RenderInputTextareaField }